import React from "react";
import "./Footer.css"; // Import a CSS file for styling
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Navigate to the desired path
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          {/* Pages Section */}
          <div className="footer-col">
            <h4>Pages</h4>
            <ul>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/")}
                >
                  Home
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/package/heritage")}
                >
                  Heritage Walks and Tours
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/package/activities")}
                >
                  Activities
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/package/conservation")}
                >
                  Conservation
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/team")}
                >
                  Our Team
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/contact-us")}
                >
                  Contact Us
                </span>
              </li>
            </ul>
          </div>

          {/* Destinations Section */}
          <div className="footer-col">
            <h4>Destinations</h4>
            <ul>
              <li>Blissful Bhuleshwar</li>
              <li>Heritage Orientation Walk</li>
              <li>Nane Ghat</li>
              <li>Old Pune Heritage Walk</li>
              <li>Aurangabad Heritage Tour</li>
            </ul>
          </div>

          {/* Quick Links Section */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/contact-us")}
                >
                  Contact Us
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/about-us")}
                >
                  About Us
                </span>
              </li>
              <li>
                <span
                  className="footer-link"
                  onClick={() => handleNavigation("/upcoming")}
                >
                  Upcoming
                </span>
              </li>
            </ul>
          </div>

          {/* Newsletter and Contact Info Section */}
          <div className="footer-col-newsletter-col">
            <h4>Subscribe to Our Newsletter</h4>
            <p>Just sign up and we'll send you a notification by email.</p>
            <form>
              <input type="email" placeholder="Enter Email Address" />
              <button type="submit">Subscribe</button>
            </form>
            <h4 className="contact-heading">Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-phone-alt"></i>
                <span>
                  Customer Support <br />
                  +91 9175 917553
                </span>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>
                  Drop Us a Mail <br /> info@waisan.in
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="rights">
          <p>
            Copyright © 2025. All Rights Reserved,{" "}
            <span>Tectigon IT Solutions Pvt Ltd</span>
          </p>
        </div>
        <div className="social-links">
          <a href="#">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="#">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#">
            <i className="fab fa-linkedin"></i>
          </a>
          <a href="#">
            <i className="fab fa-pinterest"></i>
          </a>
          <a href="#">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
        <div className="conditions">
          <p>Legal Notice</p>
          <p>Refund Policy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
